import { render, staticRenderFns } from "./NewProvider.vue?vue&type=template&id=29c63337&scoped=true&"
import script from "./NewProvider.vue?vue&type=script&lang=js&"
export * from "./NewProvider.vue?vue&type=script&lang=js&"
import style0 from "./NewProvider.vue?vue&type=style&index=0&id=29c63337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c63337",
  null
  
)

export default component.exports